import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';

/**
 * @slot - button placed within the element
 */
@Component({
  tag: 'wb-load-more',
  styleUrl: 'load-more.scss',
  shadow: true,
})
export class LoadMoreComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /**
   * The colour scheme
   * @deprecated Use `data-on` attribute instead
   **/
  @Prop({ reflect: true })
  public theme?: WorkbenchTheme;

  /** Currently active page (starts with 1 for first page) */
  @Prop()
  public currentPage: number = 1;

  /** Number of available pages */
  @Prop()
  public pages?: number;

  /** additional text to pagination */
  @Prop({ reflect: true })
  public additionalText?: string;

  /** aria-label for progress bar */
  @Prop({ reflect: true })
  public progressAriaLabel?: string;

  private TagNames = transformTagNames(this, 'wb-load-more', ['wb-text', 'wb-progress']);

  public render(): JSX.Element {
    const { WbText, WbProgress } = this.TagNames;

    return (
      <Host class="wb-load-more" data-on={getDataOnFromTheme(this.el, this.theme)}>
        <WbText size="m" static>
          {Math.min(this.currentPage, this.pages)} / {this.pages} {this.additionalText}
        </WbText>
        <WbProgress value={(this.currentPage / this.pages) * 100} rounded theme={this.theme} progressAriaLabel={this.progressAriaLabel} />
        <slot />
      </Host>
    );
  }
}
